import axios from "axios";

const API_BASE_URL = (
  process.env.REACT_APP_API_URL ||
  "https://api.bsangam.com"
).replace(/\/$/, "");

const CLIENT_BASE_URL =
  `${API_BASE_URL}/client`;

const POST_BASE_URL =
  `${API_BASE_URL}/posts`;

const ADVERTISEMENT_BASE_URL =
  `${API_BASE_URL}/advertisements`;

// ==========================
// GET ALL CLIENTS
// ==========================
export const getAllClientsApi =
  async (payload: any) => {
    try {
      const res =
        await axios.post(
          `${CLIENT_BASE_URL}/suggested-clubs`,
          payload
        );

      return res.data;
    } catch (error) {
      return {
        success: false,
        status: false,
        data: [],
        message:
          "Failed to fetch clients",
      };
    }
  };

// ==========================
// FOLLOW SINGLE CLIENT / CLUB
// ==========================
export const followClientApi =
  async (payload: any) => {
    try {
      const res =
        await axios.post(
          `${CLIENT_BASE_URL}/follow`,
          {
            client_id:
              payload.client_id,

            follower_user_id:
              payload.follower_user_id ||
              payload.user_id,

            platform:
              payload.platform ||
              "web",
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,

        message:
          error?.response?.data
            ?.message ||
          "Failed to follow club",
      };
    }
  };

// ==========================
// UNFOLLOW SINGLE CLIENT / CLUB
// ==========================
export const unfollowClientApi =
  async (payload: any) => {
    try {
      const res =
        await axios.post(
          `${CLIENT_BASE_URL}/unfollow`,
          {
            client_id:
              payload.client_id,

            follower_user_id:
              payload.follower_user_id ||
              payload.user_id,
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,

        message:
          error?.response?.data
            ?.message ||
          "Failed to unfollow club",

        error:
          error?.response?.data ||
          error?.message,
      };
    }
  };

// ==========================
// FOLLOW MULTIPLE CLIENTS / CLUBS
// ==========================
export const followMultipleClientsApi =
  async (payload: any) => {
    try {
      const res =
        await axios.post(
          `${CLIENT_BASE_URL}/follow-multiple`,
          {
            follower_user_id:
              payload.user_id,

            client_ids:
              payload.client_ids,

            platform:
              payload.platform ||
              "web",
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,

        message:
          error?.response?.data
            ?.message ||
          "Failed to follow selected clubs",
      };
    }
  };

// ==========================
// GET FOLLOWING CLUBS
// ==========================
export const getFollowingClubsApi =
  async (payload: any) => {
    try {
      const res =
        await axios.post(
          `${CLIENT_BASE_URL}/following-clubs`,
          {
            follower_user_id:
              payload.user_id ||
              payload.follower_user_id,
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,
        data: [],

        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch following clubs",
      };
    }
  };

// ==========================
// ADD POST VIEW
//
// Logged-in user:
// post_id + user_id + platform
//
// Guest user:
// post_id + visitor_key + platform
// ==========================
export const addPostViewApi =
  async (payload: {
    post_id: number | string;
    user_id?: number | string | null;
    visitor_key?: string | null;
    platform?: "web" | "mobile";
  }) => {
    try {
      const formData =
        new FormData();

      formData.append(
        "post_id",
        String(
          payload.post_id
        )
      );

      if (
        payload.user_id !==
          undefined &&
        payload.user_id !== null &&
        String(
          payload.user_id
        ).trim() !== ""
      ) {
        formData.append(
          "user_id",
          String(
            payload.user_id
          )
        );
      }

      if (
        payload.visitor_key !==
          undefined &&
        payload.visitor_key !==
          null &&
        String(
          payload.visitor_key
        ).trim() !== ""
      ) {
        formData.append(
          "visitor_key",
          String(
            payload.visitor_key
          ).trim()
        );
      }

      formData.append(
        "platform",
        payload.platform ||
          "web"
      );

      console.log(
        "ADD POST VIEW PAYLOAD =>",
        Object.fromEntries(
          formData.entries()
        )
      );

      const res =
        await axios.post(
          `${POST_BASE_URL}/view/add`,
          formData
        );

      return res.data;
    } catch (error: any) {
      console.error(
        "ADD POST VIEW ERROR =>",
        error?.response?.data ||
          error?.message ||
          error
      );

      return {
        success: false,
        status: false,

        message:
          error?.response?.data
            ?.message ||
          "Failed to add post view",

        error:
          error?.response?.data ||
          error?.message,
      };
    }
  };

// ==========================
// GET HOME FEED ADVERTISEMENTS
// ==========================
export const getAdvertisementsApi =
  async (
    userId?: number | null,
    page: number = 1,
    limit: number = 5
  ) => {
    try {
      const params: any = {
        page,
        limit,
      };

      if (
        userId &&
        Number(userId) > 0
      ) {
        params.user_id =
          Number(userId);
      }

      const res =
        await axios.get(
          `${ADVERTISEMENT_BASE_URL}/config/get`,
          {
            params,
          }
        );

      return res.data;
    } catch (error: any) {
      throw error;
    }
  };

// ==========================
// GET LINKED MEMBERS
// ==========================
export const getLinkedMembersApi =
  async (payload: any) => {
    try {
      const res =
        await axios.get(
          `${CLIENT_BASE_URL}/linked-members`,
          {
            params: {
              user_id:
                payload.user_id,

              client_id:
                payload.client_id,

              search:
                payload.search,
            },
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,
        data: [],

        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch linked members",
      };
    }
  };

// ==========================
// GET LINKED CLUBS
// ==========================
export const getLinkedClubsApi =
  async (
    user_id:
      | number
      | string
  ) => {
    try {
      const res =
        await axios.get(
          `${CLIENT_BASE_URL}/linked-clubs`,
          {
            params: {
              user_id,
            },
          }
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,
        data: [],
        clients: [],

        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch Joined clubs",
      };
    }
  };

// ==========================
// GET CLUBS
// ==========================
export const getClubsApi =
  async () => {
    try {
      const res =
        await axios.get(
          `${CLIENT_BASE_URL}/clubs`
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,
        data: [],

        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch clubs",
      };
    }
  };

// ==========================
// GET PUBLIC CLIENT BY SLUG
// ==========================
export const getPublicClientBySlugApi =
  async (
    slug: string
  ) => {
    try {
      const res =
        await axios.get(
          `${CLIENT_BASE_URL}/public/${encodeURIComponent(
            slug
          )}`
        );

      return res.data;
    } catch (error: any) {
      return {
        success: false,
        status: false,
        data: null,

        message:
          error?.response?.data
            ?.message ||
          "Failed to fetch client",
      };
    }
  };